import { Dispatch } from 'redux';
import * as Actions from './surveyCreatorActions';
import { SurveyCreatorConstants } from './surveyCreatorConstants';
import SurveyService from '../../../services/surveyService';
import { ISchema, ISchemaType } from '../../../models/Schema.model';
import { Toastr } from '../../../utils/Toastr';
import { locale } from '../../../common/localization/localizationService';

export function createSurveysListRequest(): Actions.GetSchemaTypes {
  return {
    type: SurveyCreatorConstants.GET_SCHEMA_TYPES_REQUEST,
  };
}
export function createSurveysListSuccess(
  payload: Array<ISchemaType>
): Actions.GetSchemaTypes.Success {
  return {
    type: SurveyCreatorConstants.GET_SCHEMA_TYPES_SUCCESS,
    payload,
  };
}
export function createSurveysListFailure(
  error: Error
): Actions.GetSchemaTypes.Failure {
  return {
    type: SurveyCreatorConstants.GET_SCHEMA_TYPES_FAILURE,
    error,
  };
}

export function createSaveSurveyRequest(payload: ISchema): Actions.SaveSurvey {
  return {
    type: SurveyCreatorConstants.SAVE_SURVEY_REQUEST,
    payload,
  };
}
export function createSaveSurveySuccess(
  payload: ISchema
): Actions.SaveSurvey.Success {
  return {
    type: SurveyCreatorConstants.SAVE_SURVEY_SUCCESS,
    payload,
  };
}
export function createSaveSurveyFailure(
  error: Error
): Actions.SaveSurvey.Failure {
  return {
    type: SurveyCreatorConstants.SAVE_SURVEY_FAILURE,
    error,
  };
}

export function createGetSurveyRequest(payload: number): Actions.GetSurvey {
  return {
    type: SurveyCreatorConstants.GET_SCHEMA_REQUEST,
    payload,
  };
}
export function createGetSurveySuccess(
  payload: ISchema
): Actions.GetSurvey.Success {
  return {
    type: SurveyCreatorConstants.GET_SCHEMA_SUCCESS,
    payload,
  };
}
export function createGetSurveyFailure(
  error: Error
): Actions.GetSurvey.Failure {
  return {
    type: SurveyCreatorConstants.GET_SCHEMA_FAILURE,
    error,
  };
}

export function loadSchemaTypes(
  ignoreCache: boolean = false
): (dispatch: Dispatch<Actions.All>) => Promise<void> {
  return async function (dispatch: Dispatch<Actions.All>): Promise<void> {
    dispatch(createSurveysListRequest());
    try {
      const result: Array<ISchemaType> = await SurveyService.getSchemaTypes(
        ignoreCache
      );
      dispatch(createSurveysListSuccess(result));
    } catch (error) {
      dispatch(createSurveysListFailure(error));
    }
  };
}

export function getSurvey(
  id: number
): (dispatch: Dispatch<Actions.All>) => Promise<void> {
  return async function (dispatch: Dispatch<Actions.All>): Promise<void> {
    dispatch(createGetSurveyRequest(id));
    try {
      const result: ISchema = await SurveyService.getSurvey(id);
      dispatch(createGetSurveySuccess(result));
    } catch (error) {
      dispatch(createGetSurveyFailure(error));
    }
  };
}

export function saveSurvey(
  payload: ISchema
): (dispatch: Dispatch<Actions.All>) => Promise<void> {
  return async function (dispatch: Dispatch<Actions.All>): Promise<void> {
    dispatch(createSaveSurveyRequest(payload));
    try {
      const result: ISchema = await SurveyService.saveSurvey(payload);
      dispatch(createSaveSurveySuccess(result));
      Toastr.success(locale.surveyCreator._upsertSuccess);
    } catch (error) {
      dispatch(createSaveSurveyFailure(error));
      Toastr.error(error);
    }
  };
}

export function setSelectedSchemaType(
  payload: ISchemaType
): Actions.SetSelectedType {
  return createSetScemaType(payload);
}

export function createSetScemaType(
  payload: ISchemaType
): Actions.SetSelectedType {
  return {
    type: SurveyCreatorConstants.SET_SELECTED_TYPE,
    payload,
  };
}
